import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type { GetNoteCosignMetaResponse } from "@/core/types/(api)/cosignature";

export async function getNoteCosignMeta(documentId: string): Promise<GetNoteCosignMetaResponse> {
  return cosignatureRequestsTyped.get_note_cosign_meta({ urlParams: { documentId } });
}
